<template>
  <div class="file-processing-upload-errors">
    <div v-for="(item, index) in errorsList" class="item">
      <div class="item-message">{{ index + 1 }}) {{ item.name }}</div>
      <div class="action-plan" v-show="item.action_plan">
        <div class="action-plan-title">Action Plan:</div>
        <div class="action-plan-instruction">
          {{ item.action_plan }}
        </div>
        <div class="action-plan-description">
          If you have an automated process producing the file please make sure
          this process includes the changes above and re-test until error does
          not occur.
        </div>
      </div>
      <div
        v-show="
          !(
            item.rows.length == 1 &&
            item.rows[0].field === null &&
            item.rows[0].value === null
          )
        "
      >
        <div class="download-view-errors">
          <span class="text" @click="downloadErrorFileReview(item.code)"
            >DOWNLOAD TO REVIEW AFFECTED ROWS</span
          >
        </div>
        <div class="rows_number" v-show="item.rows.length">
          Rows: {{ chronologicalSort(item.rows) | rowNumberFormat }}
        </div>
        <div class="error_rows" v-show="item.rows.length">
          <ul>
            <li v-for="row in chronologicalSort(item.rows)">
              Row № {{ row.row_number }}. Field "{{ row.field }}". Value: "{{
                row.value
              }}"
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  GETTERS_FILE_PROCESSING_UPLOAD_ERROR,
  ACTION_GET_FILE_PROCESSING_UPLOAD_ERROR,
  ACTION_DOWNLOAD_ERROR_FILE_REVIEW
} from "../../store/modules/files_processing/constants";
export default {
  name: "file-processing-error-list",
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  filters: {
    rowNumberFormat(errors) {
      if (!errors.length) return "";
      return errors.map(item => item.row_number).join(", ");
    }
  },
  beforeMount() {
    this.getFileUploadErrorAction(this.data.transactionId);
    console.log(this.data.transactionId);
  },
  methods: {
    chronologicalSort(rows) {
      let result = rows.slice().sort((a, b) => {
        return a.row_number - b.row_number;
      });
      return result;
    },
    downloadErrorFileReview: function(code) {
      const params = {
        transaction_id: this.data.transactionId,
        code: code,
        file_name: code + "_effected_row.csv"
      };
      this.downloadErrorFileReviewAction(params);
    },
    ...mapActions({
      getFileUploadErrorAction: ACTION_GET_FILE_PROCESSING_UPLOAD_ERROR,
      downloadErrorFileReviewAction: ACTION_DOWNLOAD_ERROR_FILE_REVIEW
    })
  },
  computed: {
    errorsList: function() {
      return this.getFileUploadError;
    },
    ...mapGetters({
      getFileUploadError: GETTERS_FILE_PROCESSING_UPLOAD_ERROR
    })
  }
};
</script>
<style lang="scss">
@import "~@/assets/styles/_core-variables";

.event-modal {
  .modal-body {
    overflow: auto;
    height: 500px;

    .file-processing-upload-errors {
      .item {
        margin-bottom: 30px;
        &-message {
          font-weight: 700;
        }
        .action-plan {
          margin-top: 20px;
          &-title {
            font-weight: 600;
          }
          &-description {
            margin-top: 20px;
          }
        }
        .download-view-errors {
          margin-top: 20px;
          cursor: pointer;
          .text {
            color: $cl-primary;
            font-weight: 600;
          }
        }
        .rows_number {
          margin-top: 20px;
        }
        .error_rows {
          margin-top: 20px;
          ul {
            list-style-type: none;
            padding-left: 20px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/FileProcessingUploadError.vue